import React from 'react';
import PropTypes from 'prop-types';
import { PRODUCT_CATEGORY_TYPES } from 'src/containers/product-container/ProductConstants';
import VehicleInsuranceCaseForm from '../components/VehicleInsuranceCaseForm';
import CarLoanCaseForm from '../components/CarLoanCaseForm';
import RTOVehileForm from '../components/RTOVehileForm';

function CaseMetaFactory({
    values,setFieldValue
}) {
    if (values.productCategory === PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE) {
        return <VehicleInsuranceCaseForm values={values} setFieldValue={setFieldValue}/>;
    }
    else if(values.productCategory === PRODUCT_CATEGORY_TYPES.CAR_LOAN)
    {
          return <CarLoanCaseForm values={values} /> ;
    }
    else if(values.productCategory === PRODUCT_CATEGORY_TYPES.VEHICLE_RTO)
        {
              return <RTOVehileForm values={values} /> ;
        }

    return null;
}

CaseMetaFactory.propTypes = {
    values: PropTypes.shape({
        productCategory: PropTypes.string,
    }).isRequired,
};

export default CaseMetaFactory;
